const a=(...n)=>n.reduce((r,e)=>async function*(o){for await(const t of r(o))yield*e(t)}),f=n=>function*(){for(const r of n)yield r};export{a as compose,f as generateArray};
